module.exports = __webpack_public_path__ + "img/paystatus-0.174abf4c.png";